import React from 'react';
import * as Styles from './Banner.styles';
import IconAnimation from './media/AiAnimation.webp';
import MaiaIconImage from '@/media/MaiaIA/iconImage.png';
import { Button } from 'gatorcomponents';
import { useResize } from '@/hooks/useResize';

const Banner = ({
  title,
  description,
  primaryButtonLabel,
  primaryButtonAction,
  primaryButtonRef,
  secondaryButtonLabel,
  secondaryButtonAction,
  secondaryButtonRef,
  buttonImage,
  noIcon,
}) => {
  const windowRect = useResize();
  const { width } = windowRect;
  const isMobile = width < 960;

  return (
    <Styles.Wrapper>
      <Styles.TextWrapper $noIcon={noIcon}>
        {!noIcon && (
          <Styles.AnimationWrapper>
            <Styles.AnimationIcon src={MaiaIconImage || IconAnimation} />
          </Styles.AnimationWrapper>
        )}
        {title && <Styles.Title>{title}</Styles.Title>}
        {description && <Styles.Description>{description}</Styles.Description>}
      </Styles.TextWrapper>
      <Styles.ButtonsWrapper>
        {primaryButtonLabel && (
          <Styles.ButtonContainer ref={primaryButtonRef}>
            <Button
              label={primaryButtonLabel}
              variant="secondary"
              onClick={primaryButtonAction}
              size="large"
              width={isMobile ? 'full' : 'fit-content'}
            />
          </Styles.ButtonContainer>
        )}
        {secondaryButtonLabel && (
          <Styles.ButtonContainer ref={secondaryButtonRef}>
            <Button
              label={secondaryButtonLabel}
              variant="secondary"
              onClick={secondaryButtonAction}
              size="large"
              width={isMobile ? 'full' : 'fit-content'}
              iconRight={buttonImage}
            />
          </Styles.ButtonContainer>
        )}
      </Styles.ButtonsWrapper>
    </Styles.Wrapper>
  );
};

export default Banner;
